import { Navigate, useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import EmployeeUpdatesDataCollectionPage from 'modules/compensations/pages/EmployeeUpdatesDataCollectionPage'
import { usePayrollPaywallingGuard } from 'modules/payroll_bundle/hooks/usePayrollPaywallGuard'

interface CompensationsOutletContext {
  compensationsEnabled: boolean
}

const NavigateToEmployeeUpdatesPage = () => {
  const { navigation } = useNavigation()
  const { compensationsEnabled } = useOutletContext<CompensationsOutletContext>()
  const { loadingFeatures, isPayrollAvailable } = usePayrollPaywallingGuard()

  const shouldRedirectToPayroll = !loadingFeatures && !compensationsEnabled && isPayrollAvailable

  if (loadingFeatures) {
    return (
      <Box
        gap="s8"
        padding="s48"
        alignItems="center"
        data-testid="navigate-employee-updates-loading"
      >
        <Spinner size="s40" />
      </Box>
    )
  }

  if (shouldRedirectToPayroll) {
    return <Navigate replace to={navigation.payrollBundle.incidences.fullPath()} />
  }

  return (
    <AuthorizeUser authorizeFn={() => compensationsEnabled}>
      <EmployeeUpdatesDataCollectionPage />
    </AuthorizeUser>
  )
}

export default NavigateToEmployeeUpdatesPage
